/**
 * Created by zhaohaohao
 */
import Component from "../../../../../../lib/component";
import template from './expert-search-item.html'


let expertItem = Component.extend({
    template: template,
    data: {
    },
    actions: {

    },
    afterRender: function() {

    }
})
// class expertItem extends Component {
//     constructor(data) {
//         config.data = data
//         super(config)
//     }
// }
export default expertItem


// WEBPACK FOOTER //
// app/components/dataGrid/data-table-toolbar/expert-search/expert-search-condition/expert-search-item/expert-search-item.js